import React from 'react';
import './what-to-do-card.css';

const WhatToDoCard = (props) => {
  const { card } = props;
  
  return (
    <div className={`card-what-to-do ${card.cardClass}`}>
      <div className='wrapper-what-to-do-card-title'>
        <div className={card.iconClass}>
          {card.icon}
        </div>
        <h3 className='title-sub-2'>
          {card.title}
        </h3>
      </div>
      <p className="what-to-do-content">
        {card.content}
      </p>
    </div>
  );
}

export default WhatToDoCard;
